import { OVERLAY_STATUS } from '../constants';

export const status = (status) => ({
    type: OVERLAY_STATUS,
    payload: { status },
});
